import { Button, ButtonProps, Form, FormInstance } from '@sinohealth/butterfly-ui-components';
import React, { useEffect } from 'react';

const SubmitButton = ({
  form,
  label,
  className,
  buttonProps,
}: {
  form: FormInstance;
  label?: string;
  className?: string;
  buttonProps?: ButtonProps;
}) => {
  const [submittable, setSubmittable] = React.useState(false);

  // Watch all values
  const values = Form.useWatch([], form);

  useEffect(() => {
    let isMounted = true; // 添加一个标志来追踪组件是否已卸载

    try {
      form.validateFields().then(
        () => {
          if (isMounted) {
            console.log(1111);
            setSubmittable(true);
          }
        },
        () => {
          if (isMounted) {
            console.log(2222);
            setSubmittable(false);
          }
        },
      );
    } catch (err) {
      console.log(err);
    }

    // 在清理函数中取消异步操作和订阅
    return () => {
      isMounted = false;
    };
  }, [values]);

  return (
    <Button
      type="primary"
      className={className}
      htmlType="submit"
      disabled={!submittable}
      {...buttonProps}
      style={{
        backgroundImage: submittable ? 'linear-gradient(228deg, #217ba0 0%, #46A0C0 100%)' : 'none',
        ...buttonProps?.style,
      }}
    >
      {label}
    </Button>
  );
};

export default SubmitButton;
